import { getImage } from "gatsby-plugin-image";
import { ContentType, ContentTypeWithImageData } from "../../../types";
import { BlogPageData } from "../../pages/Blog";
import { GATSBY_SITE_URL } from "../../pages/Page";

export const getBlogPageData = (content: Partial<ContentTypeWithImageData>): BlogPageData => {
    try {
        const data = JSON.parse(content.data) as BlogPageData;
        const imageFile = content.imageFile;
        const gatsbyImageFile = content.imageFile ? getImage(content.imageFile) : undefined;
        return {
            id: content.id,
            ...data,
            ogContent: content,
            imageFile,
            gatsbyImageFile,
            origin: GATSBY_SITE_URL
        };
    } catch (e) {
        console.log("getBlogPageData", e);
        return {};
    }
};
export const getDisplayBlogItems = (content: Partial<ContentType>[], count: number) => {
    const items = content
        .map(item => {
            const contentData = getBlogPageData(item);
            return contentData;
        })
        .filter(item => !item.disabled)
        .slice(0, count)
        .sort((a, b) => {
            const aDt = a.date;
            const bDt = b.date;
            if (!aDt || !bDt) {
                return 0;
            }
            if (aDt > bDt) {
                return -1;
            }
            if (aDt < bDt) {
                return 1;
            }
            return 0;
        });
    return items;
};
